import Button from "@/components/Button";

export default function TalkItOutButton({
  listening,
  onClick,
  testId
}: {
  listening: boolean;
  onClick: () => void;
  testId: string;
}) {
  return (
    <div>
      <p className="sr-only" role="status" aria-live="polite">
        {listening ? "Listening" : ""}
      </p>
      <Button
        type="button"
        variant={listening ? "filled" : "filledTonal"}
        icon="mic"
        ariaLabel={listening ? "Stop Dictating" : "Talk it Out"}
        testId={testId}
        onClick={onClick}
      >
        {listening ? "Stop Dictating" : "Talk it Out"}
      </Button>
    </div>
  );
}
